const emailRegex = /^[^\s@#/]+@[^\s@#/]+\.[^\s@#/]{2,}$/;

export function validateCheckoutBilling({
  terms,
  firstName,
  lastName,
  phone,
  email,
}) {
  const normalizedFirstName = (firstName || "").trim();
  const normalizedLastName = (lastName || "").trim();
  const normalizedEmail = (email || "").trim().toLowerCase();
  const normalizedPhone = String(phone || "").replace(/\D/g, "");

  if (!terms) {
    return "You have NOT been charged! Please agree to the Terms and Conditions before proceeding";
  }
  if (!normalizedFirstName) {
    return "Please enter your first name";
  }
  if (!normalizedLastName) {
    return "Please enter your last name";
  }
  if (normalizedPhone.length < 10) {
    return "Please enter a valid 10-digit U.S. phone number";
  }
  if (!normalizedEmail || !emailRegex.test(normalizedEmail)) {
    return "Please enter a valid email address";
  }

  return null;
}
